import React from 'react';
import PropTypes from 'prop-types';
import { useFormValidation } from '@pattern-library/base';
import { Button, FlexButtonGroup } from '@pattern-library/buttons';
import TextInput from '@pattern-library/text-input';

const propTypes = {
    formAction: PropTypes.string.isRequired,
    antiForgeryToken: PropTypes.string.isRequired,
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    emailInputProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        .isRequired
};

function ConfirmEmailAddressForm(props) {
    const { formAction, antiForgeryToken, buttonProps, emailInputProps } = props;

    const schema = {
        [emailInputProps.name]: [
            {
                validationMethod: 'required',
                errorMessage: 'Enter an email address'
            },
            {
                validationMethod: 'email',
                errorMessage: 'Please enter a valid email address'
            }
        ]
    };
    const { onSubmit, hasError, errorMessage } = useFormValidation({ schema });

    return (
        <form action={formAction} method="post" onSubmit={onSubmit} autoComplete="off" noValidate>
            <div dangerouslySetInnerHTML={{ __html: antiForgeryToken }} />
            <TextInput
                {...emailInputProps}
                isRequired
                type="email"
                hasError={hasError(emailInputProps.name)}
                errorMessage={errorMessage(emailInputProps.name)}
            />

            <FlexButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                <Button type="submit" className="asc-mtb-0" {...buttonProps} />
            </FlexButtonGroup>
        </form>
    );
}

ConfirmEmailAddressForm.propTypes = propTypes;
export default ConfirmEmailAddressForm;
